import { VBox } from "@ui/box/Box";
import { useRef } from "react";
import { TFeaturedComponent } from "src/Featuresmap";
import { IClient } from "src/services/ClientService";
import { useDimensions } from "src/utils/useDimensions";
import { StatView } from "src/view/StatView";

export interface IClientPageSummaryProps {
	client: IClient;
}

export const ClientPageSummary: TFeaturedComponent<IClientPageSummaryProps> = ({ client }: IClientPageSummaryProps) => {
	//const [project] = GD.B_SELECTED_PROJECT.use();
	//const [user] = GD.REQ_PROFILE.useValue(undefined, undefined, [project]);

	//const showStat = user && SETTINGS_ALLOWED_IDS.includes(user.id);

	const pageRef = useRef<HTMLDivElement>(null);
		const { width } = useDimensions(pageRef);
		let statSize = 4;
		if (width < 500) statSize = 1;
		else if (width < 740) statSize = 2;
		else if (width < 1150) statSize = 3;

	return (
		<VBox sx={{ paddingTop: "16px" }} ref={pageRef}>
			<StatView size={statSize} client_id={client.id} type="client" preserveClientComparison />
		</VBox>
	);
};

ClientPageSummary.feature = "client_summary";
